module.exports = __webpack_public_path__ + "media/assets/icons/agreements-da05829a335d67d23483d2026a705031.svg";